export const API_URL = import.meta.env.VITE_API_BASE_URL || '/api';
export const API_BASE_PATH =
  import.meta.env.VITE_APP_BASE_API_PATH || 'bees-management';
export const DOWNLOAD_BASE_URL =
  import.meta.env.VITE_FILE_DOWNLOAD_BASE_URL || '/';
export const API_MOCK_URL =
  import.meta.env.VITE_API_MOCK_URL || `${window.origin}/assets/mock/`;
export const BOOTSTRAP_API_PREFIX = `${API_BASE_PATH}/um/workspaces/:wid/bootstrap`;
export const API_PANEL_BASE_URL = import.meta.env.VITE_API_PANEL_BASE_URL;
export const API_PANEL_PREFIX = `${API_PANEL_BASE_URL}/developer-portal`;
